import React, { useEffect } from "react"
import OrderFormPage from "./OrderFormPage.jsx"

export default function OrderFormNewPage() {
    useEffect(() => {
        document.activeElement?.blur?.()
        window.scrollTo({ top: 0, left: 0, behavior: "instant" })
    }, [])
    return <OrderFormPage key="order-form:new" />
}

